export function postReorder(comp, data, endpoint, fn) {
    $.each(data, function(index, value) {
        value.sort_by = index + 1;
    });

    const api = comp.$store.state.api + endpoint;

    comp.$http.post(api, { data: data }).then(res => {
        comp.ordered = fn(data);
        comp.$message(null, "Ordenação efetuada com sucesso", "success");
    }).catch((err) => console.error(err));
}



// WEBPACK FOOTER //
// ./src/utils.js